export const FILTER_TYPE_TEXT = "FILTER_TYPE_TEXT";
export const FILTER_TYPE_MULTISELECT = "FILTER_TYPE_MULTISELECT";
export const FILTER_TYPE_YESNO = "FILTER_TYPE_YESNO";
export const FILTER_TYPE_DATE = "FILTER_TYPE_DATE";
export const FILTER_TYPE_DATETIME = "FILTER_TYPE_DATETIME";
export const FILTER_TYPE_SWITCH = "FILTER_TYPE_SWITCH";
export const FILTER_TYPE_INTEGER = "FILTER_TYPE_INTEGER";
export const FILTER_TYPE_SELECT = "FILTER_TYPE_SELECT";

export function getBlankDetails(resetTestingTools = false) {
  const details = {
    lookups_url: null,
    providers_url: null,
    exceptionlogs_url: null,
    swagger_url: null,
    disclaimer_url: null,
    copyright_url: null,
    privacy_url: null,
    environment: null,
    sap_using_dummy_gateway: false,
    testing_tools_enabled: false,
    mfa_mode: null,
    build: null,
    database_build: null,
    client_build: null,
    sortable_list_row_limit: null,
    loaded: false,
    loading: false
  };
  if (resetTestingTools) {
    details.disableTestingTools = false;
  }
  return details;
}

export function getBlankAppSettings() {
  return {
    environmentWebRootUrl: null,
    environmentClientBuild: null,
    environmentSortableListRowLimit: null,
    environmentMigrateDatabase: null,
    environmentPrivacyUrl: null,
    environmentDisclaimerUrl: null,
    environmentCopyrightUrl: null,
    securityDaysInactivityBeforeLockingAccount: null,
    securityJwtTokenExpiryInMinutes: null,
    securityPasswordEncryptionStrength: null,
    securityPasswordExpiryPeriodInDays: null,
    testingEnableEfProfiler: null,
    testingEnableTestingTools: null,
    emailServer: null,
    emailAddressOverride: null,
    emailDisabled: null,
    databaseConnectionString: null,
    databaseConnectionStringForHits: null,
    databaseConnectionStringForPrisms: null,
    databaseConnectionStringForUnistats: null,
    databaseConnectionStringForVslDatamart: null,
    sapUseDummyGateway: null,
    sapConfigurations: []
  };
}

export function getBlankSapConfigurationRecord() {
  return {
    companyCode: null,
    generalLedgerAccountId: null,
    costCentreId: null
  };
}
